import React, { useState } from 'react';
import { Button, Form, FormGroup, Input } from 'reactstrap';
//Images, Icons
import  staff from '../../images/agent.jpg';
import ContactBG from '../../images/contact_bg.mp4';

//Styles
import './QuoteForm.css';
//Component
import Header from '../Header/Header';


const QuoteForm = () => {

    const handleSubmit = () => { 
        console.log("quote submit working");
        alert('Thank you! Our team will contact you within 24 hrs!');
        
    }
    return (
    <>
        <Header color={'var(--DarkNavy)'} barColor={'var(--Blue)'} bg={'none'}/>
        <div className="quote__frame">
            <div className="contact__background">
                <video  autoPlay loop muted> 
                    <source src={ContactBG} type='video/mp4' />
                </video>
            </div>
            <div className="quote__wrapper">
                <div className="quote__container">
                    <div className="quote__content">
                        <h1 className="quote__header">
                            Talk to us and Get a Free & Quick Quote!
                        </h1>
                        <div className="quote__bar"></div>
                        <div className="quote__form">
                            <div className="quote__left">
                                <img src={staff} alt="staff" className="staff" />
                                <h5>24h/7d quick & smart quote</h5>
                            </div>
                            <Form onSubmit={handleSubmit} className="quote__formBody" action="/">
                                <FormGroup className="quote__formInput">
                                    <Input type="text" id="name" name="name" placeholder="full name"/* innerRef={input => name = input} */ />
                                </FormGroup>
                                <FormGroup className="quote__formInput">
                                    <Input type="text" id="phone" name="phone" placeholder="phone"/*innerRef={input => phone = input} */ />
                                </FormGroup>
                                <FormGroup className="quote__formInput">
                                    <Input type="text" id="phone" name="email" placeholder="email" /*innerRef={input => email = input} */ />
                                </FormGroup>
                                <FormGroup className="quote__formInput">
                                    <Input type="textarea" name="inquiry" className="textarea" placeholder="Scope of work for quote or any other inquiry" rows="4" cols="50"/* innerRef={input => remember = input} */ />
                                </FormGroup>
                                <div className="quote__buttons">
                                    <Button type="submit" value="submit" onSubmit={handleSubmit}>GET A QUOTE</Button>
                                    <Button type="submit" value="close">CANCEL</Button>
                                </div>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
    );
}

export default QuoteForm;